import { Action } from "redux";
import { CampaignListState, initialCampaignListState } from "./state";
import {
    getCampaignsListRequest,
    postCampaignRequest,
    purchaseCampaignByIdRequest,
    updateCampaignByIdRequest,
    getCampaignSpentBudgetRequest
} from "@common";
import { selectCampaignAction, selectPurchasedCampaignNameAction } from "./actions";
import { FETCH_STATE_INITIAL, FetchingState } from "rd-redux-http";

export function campaignListReducer(
    state: CampaignListState = initialCampaignListState,
    action: Action
): CampaignListState {
    if (getCampaignsListRequest.actions.isMy(action)) {
        return {
            ...state,
            campaigns: getCampaignsListRequest.reducer(state.campaigns, action)
        };
    }

    if (getCampaignSpentBudgetRequest.actions.isMy(action)) {
        return {
            ...state,
            campaignSpentBudget: {
                ...state.campaignSpentBudget,
                [action.params.campaignId]: getCampaignSpentBudgetRequest.reducer(
                    state.campaignSpentBudget[action.params.campaignId] || { fetchState: FetchingState.INITIAL },
                    action
                )
            }
        };
    }

    if (selectCampaignAction.is(action)) {
        return {
            ...state,
            selectedCampaignId: action.campaignId,
            selectedPurchasedCampaignName: undefined
        };
    }
    if (selectPurchasedCampaignNameAction.is(action)) {
        return {
            ...state,
            selectedPurchasedCampaignName: action.campaignName,
            selectedCampaignId: undefined
        };
    }

    if (postCampaignRequest.actions.isMy(action)) {
        return {
            ...state,
            campaigns: { fetchState: FETCH_STATE_INITIAL }
        };
    }
    if (purchaseCampaignByIdRequest.actions.isMy(action)) {
        return {
            ...state,
            campaigns: { fetchState: FETCH_STATE_INITIAL }
        };
    }
    if (updateCampaignByIdRequest.actions.isMy(action)) {
        return {
            ...state,
            campaigns: { fetchState: FETCH_STATE_INITIAL }
        };
    }

    return state;
}
